<template>
  <b-container>
    <b-row>
      <h1>{{ $t("system.systemFieldType.create") }}</h1>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
    </b-row>

    <crud-data
      ref="CrudData"
      :model="model"
      :modelstate="modelstate"
      class="mb-4"
    ></crud-data>

    <b-button class="button" size="sm" @click="save" :disabled="submitted">
      {{ $t("geral.save") }}
    </b-button>
    <!-- {{ model }} -->
  </b-container>
</template>

<script>
export default {
  name: "CreateSystemFieldType",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    CrudData: () =>
      import("@/components_rms/System/SystemFieldType/CrudData.vue"),
  },
  props: {
    systemIntegrationId: String,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Registro criado com sucesso",
      },
      submitted: false,
      modelstate: {},
      model: {},
    };
  },
  created() {
    this.newModel();
  },
  methods: {
    newModel() {
      this.model = {
        id: 0,
        DefaultValue: "",
        DefaultGeraAnomalia: 2,
        DefaultPermiteAnexo: false,
        DisplayName: "",
        FieldType: 7,
        ScriptPythonLoadData: "",
        ScriptPythonProcess: "",
        SystemIntegrationId: parseInt(this.systemIntegrationId),
      };
    },
    save() {
      this.submitted = true;
      this.$apiChecklist
        .post("/systemFieldType/create", this.model)
        .then((response) => {
          if (response.data.success) {
            this.newModel();
            this.$refs.alert.show();
          } else {
            this.alert.error = response.data.title;
            this.$refs.fadeAlertDanger.show();
          }
          this.modelstate = {};
          window.scrollTo(0, 0);
          this.submitted = false;
        })
        .catch((error) => {
          this.submitted = false;
          this.modelstate = {};
          if (error.response) {
            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
              this.alert.error = "Verifique os dados informados";
            } else {
              if (error.response.data) {
                this.alert.error = error.response.data.errors;
              } else {
                this.alert.error = `${error.response.status} - ${error.response.statusText} `;
              }
            }
          } else {
            this.alert.error = error.message;
          }
          this.$refs.fadeAlertDanger.show();
          window.scrollTo(0, 0);
        });
    },
  },
};
</script>
